<div class="form-group lms_add_employer">
  <input
    class="form-control"
    type="text"
    placeholder="Employer name *"
    id="searchValue"
    #searchValue
    required
    [class.ng-invalid]="!selectedEmployer || selectedEmployer.tnumber === 0"
    [class.ng-valid]="selectedEmployer && selectedEmployer.tnumber > 0"
    noSpecial
    uppercase
    role="combobox"
    [attr.aria-expanded]="isDropdownVisible()"
    aria-autocomplete="list"
    autocomplete="off"
    aria-controls="empSelectList"
    [attr.aria-activedescendant]="highlightedIndex >= 0 ? 'emp-option-' + highlightedIndex : null"
    (focus)="onInputFocus()"
    (blur)="onInputBlur()"
    (input)="quickSearch($any($event.target))"
    (keydown)="onKeyDownHandler($event)" />

  <!-- Loading spinner -->
  <div *ngIf="isLoading$ | async" class="loading-spinner spinner">
    <div class="rect1"></div>
    <div class="rect2"></div>
    <div class="rect3"></div>
    <div class="rect4"></div>
    <div class="rect5"></div>
  </div>

  <!-- Add new employer button -->
  <button
    *ngIf="currentSearchTerm && !showAddButton && !dontAdd && (selectedEmployer.tnumber === 0)"
    class="btn btn-floating btn-icon fs-5 fas"
    mdbRipple
    color="primary"
    (click)="onAddNewClick()"
    type="button">
    <i class="fas fa-xs fa-building-circle-arrow-right"></i>
  </button>
</div>

<!-- Dropdown list -->
<ng-container *ngIf="(employer$ | async) as employers">
  <div class="autocomplete-container" *ngIf="isDropdownVisible()" id="empSelectList" role="listbox">
    <!-- Employer results -->
    <div
      *ngFor="let item of employers; let i = index; trackBy: trackByEmployer"
      [id]="'emp-option-' + i"
      class="autocomplete-item"
      [class.active]="i === highlightedIndex"
      role="option"
      [attr.aria-selected]="i === highlightedIndex"
      (mouseenter)="highlightedIndex = i"
      (mousedown)="$event.preventDefault()"
      (click)="employerSelected(item)">
      <span [innerHTML]="item.name | highlightSearch: item"></span>
      <small class="item-category">Employer</small>
    </div>

    <!-- Empty state -->
    <div *ngIf="employers && employers.length === 0" class="no-results">
      No employers found for "<strong>{{ currentSearchTerm }}</strong>"
    </div>
  </div>
</ng-container>

